import { render, staticRenderFns } from "./EnvelopeLight.vue?vue&type=template&id=6db21f80"
import script from "./EnvelopeLight.vue?vue&type=script&lang=ts"
export * from "./EnvelopeLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports